import { memo } from "react";
import { Handle, Position, NodeProps } from "@xyflow/react";
import {
  StyledPopupNode,
  StyledPopupNodeContent,
  StyledNodeAddButton,
  StyledNodeDeleteButton,
  StyledNodeDetail,
  StyledNodeHover,
  StyledNodeTitle,
  StyledPopupNodeHeader,
  StyledPopupNodeBody,
} from "./index.styled";
import { MessageBotNodeData, MessageBotNodesEnum } from "@lib/types/MessageBot";
import { useTypedDispatch } from "@lib/redux";
import { deleteNode, setAddNodeModal } from "@lib/redux/slices/messageBot";
import { FaCheckCircle } from "react-icons/fa";
import { messageBotNodeInfos } from "@lib/constants/MessageBot";

const PopupNode = (props: NodeProps) => {
  const dispatch = useTypedDispatch();
  const { selected, id, type } = props;
  const nodeInfos = messageBotNodeInfos[MessageBotNodesEnum.POPUP];
  const { label } = props.data as MessageBotNodeData<MessageBotNodesEnum.POPUP>;

  return (
    <>
      <StyledPopupNode selected={selected}>
        <Handle type="target" position={Position.Top} />
        <Handle type="target" position={Position.Left} />
        <Handle type="source" position={Position.Bottom} />
        <Handle type="target" position={Position.Right} />

        <StyledPopupNodeContent
          selected={selected}
          width={nodeInfos.size.width}
          height={nodeInfos.size.height}
        >
          <StyledPopupNodeHeader>
            <div className="dots">
              <div className="middle-dot" />
              <div className="middle-dot" />
              <div className="middle-dot" />
            </div>
            <StyledNodeTitle>{type}</StyledNodeTitle>
          </StyledPopupNodeHeader>

          <StyledPopupNodeBody>
            <FaCheckCircle />
            <StyledNodeDetail>{label}</StyledNodeDetail>
          </StyledPopupNodeBody>

          <StyledNodeHover className="node-actions">
            <StyledNodeDeleteButton
              size={8}
              onClick={() => {
                dispatch(deleteNode(id));
              }}
            />

            <StyledNodeAddButton
              size={8}
              onClick={() =>
                dispatch(
                  setAddNodeModal({
                    isOpen: true,
                    parentId: id,
                  }),
                )
              }
            />
          </StyledNodeHover>
        </StyledPopupNodeContent>
      </StyledPopupNode>
    </>
  );
};

export default memo(PopupNode);
